module.exports = {"path":"/404.html","body":"<h1>404 SEITE NICHT GEFUNDEN</h1>\n<p>Hier gibt es leider nichts. Auch nichts Goldenes.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 978
// module chunks = 0